import { render, staticRenderFns } from "./IconPrice.vue?vue&type=template&id=28770420&"
import script from "./IconPrice.vue?vue&type=script&lang=js&"
export * from "./IconPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports